// AllPatientsFiltersCard.jsx
import PropTypes from "prop-types";
import { Card, Radio } from "antd";

export default function AllPatientsFiltersCard({ programType, onProgramTypeChange, t }) {
  const handleProgramTypeChange = (nextProgramType) => {
    if (nextProgramType !== "PACE") return;
    onProgramTypeChange(nextProgramType);
  };

  return (
    <Card className="patient-filters-card" bodyStyle={{ padding: 16 }}>
      <div className="patient-filters-row">
        {/* Texte de contexte pour la vue globale */}
        <div className="patient-filters-left">
          <div className="patient-filters-label">
            {t ? t("Filtres") : "Filtres"}
          </div>
          <div style={{ opacity: 0.75 }}>
            {t ? t("Statistiques pour tous les patients") : "Statistiques pour tous les patients"}
          </div>
        </div>

        {/* Choix du programme (PACE / MATCH / PATH) */}
        <div className="patient-filters-right">
          <Radio.Group
            value={programType}
            onChange={(e) => handleProgramTypeChange(e.target.value)}
            buttonStyle="solid"
            className="patient-filters-radio"
          >
            <Radio.Button value="PACE">PACE</Radio.Button>
            <Radio.Button value="MATCH">MATCH</Radio.Button>
            <Radio.Button value="PATH">PATH</Radio.Button>
          </Radio.Group>
        </div>
      </div>
    </Card>
  );
}

AllPatientsFiltersCard.propTypes = {
  programType: PropTypes.oneOf(["PACE", "MATCH", "PATH"]).isRequired,
  onProgramTypeChange: PropTypes.func.isRequired,
  t: PropTypes.func,
};
